import { Tag } from 'antd';
import React from 'react';
import { CustomBtnProps } from '../../interfaces';
import './styles.scss';
import classNames from 'classnames';

const CustomTag: React.FC<CustomBtnProps> = props => {
  const { nameTag, color, textColor, pointer, ...res } = props;
  const className = `${pointer ? 'ant-tag-pointer' : ''} ${nameTag || ''}`;
  return (
    <Tag
      {...res}
      className={classNames(className, 'custom-tag')}
      style={{
        backgroundColor: color,
        color: textColor,
        borderColor: textColor,
        textAlign: 'center',
      }}
    />
  );
};

export default CustomTag;
